import { useRef } from "react";

import { useDraggable, useDroppable } from "@dnd-kit/core";
import classNames from "classnames";
import { useInView } from "react-intersection-observer";

import { DRAGGABLE_TYPES } from "../constants";
import DndIndicator from "../Indicator";

const DragDropContainer = ({
  id,
  index,
  data,
  render,
  isDragAndDropDisabled = false,
}) => {
  const {
    attributes,
    listeners,
    isDragging,
    setNodeRef: setDraggableNodeRef,
  } = useDraggable({
    data: { ...data, index, type: DRAGGABLE_TYPES.ITEM, direction: "vertical" },
    id: `draggable-item--${id}`,
    disabled: isDragAndDropDisabled,
  });

  const { isOver, setNodeRef: setDroppableNodeRef } = useDroppable({
    data: { ...data, accepts: [DRAGGABLE_TYPES.ITEM], index: index + 1 },
    id: `droppable-item--${id}`,
  });

  const isIndicatorVisible = !isDragging && isOver;

  return (
    <div
      className={classNames("relative h-full w-full select-none", {
        "opacity-65": isDragging,
      })}
      ref={node => {
        setDraggableNodeRef(node);
        setDroppableNodeRef(node);
      }}
      {...(!isDragAndDropDisabled && attributes)}
      {...(!isDragAndDropDisabled && listeners)}
    >
      {render()}
      {isIndicatorVisible && <DndIndicator layout="horizontal" />}
    </div>
  );
};

const ItemContainer = props => {
  const mutables = useRef({ containerHeight: 128 }).current;

  const [setViewRef, inView] = useInView({
    onChange: (inView, entry) => {
      if (inView) return; // We need the last height value when elements moves out.
      mutables.containerHeight = entry.target.clientHeight;
    },
  });

  return (
    <div
      className="neeto-molecules-boardview-section__card relative shrink-0"
      id={props.id}
      style={{ height: inView ? undefined : mutables.containerHeight }}
      ref={node => {
        setViewRef(node);
      }}
    >
      {inView && <DragDropContainer {...props} />}
    </div>
  );
};

export default ItemContainer;
